import { Component, OnInit } from '@angular/core';
import { NgbActiveModal } from '@ng-bootstrap/ng-bootstrap';
import { FormControl, Validators } from '@angular/forms';
import { FormRecord } from '@angular/forms';
import { NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SettingsService } from 'src/app/services/settings.service';
import { LanguageSelectorComponent } from '../../common/language-selector/language-selector.component';
import { CustomerService } from 'src/app/services/customer.service';
import { Title } from '@angular/platform-browser';
import { Router } from '@angular/router';
import { AuthService } from 'src/app/services/auth.service';

@Component({
  selector: 'app-require-details',
  templateUrl: './details.component.html',
  styleUrls: ['./details.component.scss'],
})
export class DetailsComponent  implements OnInit {
  sending = false

  form = new FormRecord({
    first_name: new FormControl('', [Validators.required]),
    last_name: new FormControl('', [Validators.required]), 
    mobile_phone: new FormControl('', [Validators.pattern("^[0-9+ ]+")]),
  })
  
  constructor(
    private modalService: NgbModal,
    private customerService: CustomerService,
    private settingsService: SettingsService,
    private activeModal: NgbActiveModal,
    private titleService: Title,
    private authService: AuthService
   ) { }

  ngOnInit() {
    this.titleService.setTitle($localize`Personal information`)

    this.customerService.current().subscribe(contact => {
      console.log(contact)
      this.form.patchValue(contact)
    })
  }

  languageSelector() {
    const modal = this.modalService.open(LanguageSelectorComponent, { centered: true, size: 'md' })
  }

  save() {
    this.sending = true

    this.settingsService.save(this.form.value).subscribe({
      next: () => {
        this.sending = false
        this.customerService.ping().subscribe({
          next: () => {
            this.activeModal.close()
            this.authService.loginNavigate()
          },
          error: () => this.activeModal.close()
        })
      },
      error: () => {
        this.sending = false
      }
    })
  }
}
